export default __webpack_public_path__ + "static/media/petcloud-paw.7f7892ae.svg";